export function isAuthProviderError(obj: unknown): obj is { description: string } {
  return !!obj && typeof obj === 'object' && 'description' in obj!;
}

export function isUserAlreadyExistsError(obj: unknown): boolean {
  if (!obj || typeof obj !== 'object') return false;
  const err = obj as Record<string, unknown>;

  if (err.code === 'user_exists') return true;
  // Fallback: some Auth0 tenants surface duplicate-email signup as invalid_signup
  return err.code === 'invalid_signup' && typeof err.description === 'string' && /already exists/i.test(err.description);
}
